<template>
	<div>
		<titles titlename="系统设置" titlecontent="" :mbx="paths"></titles>
		<filters :rooms="filterslist"></filters>
		<transition>
			<div class="orderstable" v-if="sletejg == 1">
				<p class="schooltitle">
					<span class="el-icon-s-management"></span>
					<span>系统设置</span>
					<!-- <span class="schoolconten">共查询到<i>{{tablednums}}条</i>符合的记录</span> -->
				</p>
				<div class="tabslis">
					<template>
						<el-table :data="setinglist" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="index" label="序号" width="60"></el-table-column>
							<el-table-column prop="pa_setType" label="参数名称">
								<template slot-scope="scope">
									<p>{{ scope.row.pa_setType }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="parValues" label="参数值">
								<template slot-scope="scope">
									<input type="text" v-model="scope.row.parValues" />
								</template>
							</el-table-column>
							<el-table-column prop="pa_explain" label="说明">
								<template slot-scope="scope">
									<textarea rows="3" cols="40" v-model="scope.row.pa_explain"></textarea>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>

				<div class="center" @click="savesetting()"><p>保存</p></div>
			</div>
		</transition>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import filters from '@/components/filters/filtersetting.vue';
import { GetbjGetSchoolList, GetParameterList, ParameterInsertOrEdit } from '@/request/api/mange/mange.js';
import AppOptions from '@/config/AppOptions.vue';

export default {
	beforeMount() {
		this.siguids = localStorage.getItem('siguid');
		this.getscool();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {},
	data() {
		return {
			paths: [
				{
					path: '/system/systemsrrtting',
					name: '系统设置'
				}
			],
			filterslist: {
				name: '系统设置',
				content: '',
				filterlist: [
					{
						id: 0,
						indexsshol: 0,
						title: '所属院校',
						childers: []
					}
				]
			},
			setinglist: [],
			schoollist: [],
			siguids: localStorage.getItem('siguid'),
			sletejg: 0,
			tablednums: 10,
			pathsa: ''
		};
	},
	methods: {
		// 保存设置界面
		savesetting() {
			// console.log(this.setinglist)
			let paths = 'SavePath';
			let pathsa = '';

			this.setinglist.forEach((item, index) => {
				if (item.pa_setNumber == paths) {
					pathsa = item.pa_parValues;
				}

				item.si_guid = this.siguids == '' ? localStorage.getItem('siguid') : this.siguids;
			});
			this.setinglist.forEach(item => {
				if (item.pa_explain.indexOf('路径') != -1 && item.pa_parValues != item.parValues) {
					item.pa_parValues = pathsa + item.parValues;
				} else {
					item.pa_parValues = item.parValues;
				}
			});

			console.log(this.setinglist);

			let setinobj = {
				data: this.setinglist
			};

			ParameterInsertOrEdit(setinobj).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.$router.go(0);
					this.getsettindlist();
				}
			});
		},

		changescholl(id) {
			this.siguids = id;
			this.getsettindlist();
		},
		getsettindlist() {
			GetParameterList(this.siguids == '' ? localStorage.getItem('siguid') : this.siguids).then(res => {
				// console.log(res)
				this.setinglist = res.data.data;
				let paths = 'SavePath';
				let pathsa = '';

				this.setinglist.forEach((item, index) => {
					if (item.pa_setNumber == paths) {
						pathsa = item.pa_parValues;
					}
				});

				// console.log("拿到的路径",pathsa)
				this.pathsa = pathsa;
				this.setinglist.forEach((item, index) => {
					if (item.pa_setNumber == paths) {
						item.parValues = item.pa_parValues;
					} else {
						if (item.pa_parValues.indexOf(pathsa) != -1) {
							item.parValues = item.pa_parValues.replace(pathsa, '');
							// console.log(pathsa, "拿到的路径", item.pa_parValues)
						} else {
							item.parValues = item.pa_parValues;
						}
					}
				});

				this.sletejg = 1;
			});
		},

		getscool() {
			let allobj = {
				si_name_cn: '全部',
				shoolid: 0,
				si_guid: localStorage.getItem('siguid')
			};
			GetbjGetSchoolList().then(res => {
				// console.log(res, "院校不分页")
				this.schoollist = JSON.parse(JSON.stringify(res.data.data));
				if (this.schoollist.length == 1) {
					this.siguids = res.data.data[0].si_guid;

					this.getsettindlist();
				} else {
					this.siguids = '';
					this.getsettindlist();
					this.schoollist.unshift(allobj);
				}

				this.schoollist.forEach(item => {
					item.name = item.si_name_cn;
				});
				this.filterslist.filterlist[0].childers = this.schoollist;
			});
		}
	},
	components: {
		titles,
		filters
	}
};
</script>

<style scoped lang="less">
/* 设置持续时间和动画函数 */
.v-enter-active,
.v-leave-active {
	transition: all 0.8s ease;
}

.v-enter,
.v-leave-to {
	transform: translateX(-100px);
	opacity: 0;
}

.center {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
	// padding: 0.4rem 1rem;

	p {
		border: 1px solid transparent;
		border-radius: 1rem;
		background-color: #17a001;
		width: 10%;
		text-align: center;
		color: #fff;
		padding: 0.4rem 0;
		cursor: pointer;
	}
}

textarea {
	border: 1px solid #ccc;
	padding: 0.4rem;
}

input {
	border: 1px solid #ccc;
	padding: 0.4rem;
	box-sizing: border-box;
	width: 80%;
}

.orderstable {
	margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #ffa319;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar-thumb {
			background: linear-gradient(to right, #2e61bf, #60c363);
			width: 1px;
			border-radius: 4px;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			th {
				text-align: center;
				color: #333;
				font-weight: 600 !important;
			}

			td {
				text-align: center;
				button {
					color: #fff;
					border-radius: 5px;
				}

				.looking {
					background: #0d6efd;
					margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #ffa319;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		.schoolconten {
			font-size: 0.8rem;
			margin-left: 0.6rem;
			color: #333;
			letter-spacing: 1px;

			i {
				color: red;
			}
		}

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			width: 3rem;
			height: 3rem;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 2rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #ffa319;
			color: #fff;
		}
	}
}

.hello {
	height: 100vh;
}

.con {
	display: inline-flex;
	width: 8%;
	position: relative;
	height: 100%;
}

.con div {
	width: 0;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	color: #fff;
	font-size: 36px;
	font-style: italic;
}

.con .i1 {
	background: lightyellow;
	font-style: italic;
}

.con .i2 {
	background: green;
	animation: move 0.6s 0.7s linear forwards;
}

.con .i3 {
	background: hotpink;
	animation: move 0.6s 1.4s linear forwards;
}

.con .i4 {
	background: pink;
	animation: move 0.6s 2.1s linear forwards;
}

.con .i5 {
	background: lightpink;
	animation: move 0.6s linear forwards;
}

@keyframes move {
	0% {
		width: 0;
	}

	100% {
		width: 100%;
	}
}
</style>
